// export const MyText = (as = 'p') =>
//     styled(as)((props) => ({
//         position: props?.position || '',
//         fontSize: props?.size || props?.theme.fonts.fontSize?.FH28,
//         color: props?.color || props?.theme.colors?.White,
//         fontWeight: props?.weight || props?.theme.fonts.fontWeight.FW600,
//         textAlign: props?.align || 'left',
//         lineHeight: props?.lineHeight || props?.theme.fonts.lineHeight.LH34,
//         bottom: props?.bottom || '',
//         marginTop: props?.marginTop || ''
//     }))

import styled, { css } from 'styled-components'

const TextWrapper = styled.span`
  font-size: ${({ fontSize }) => fontSize || '16px'};
  color: ${({ color, props }) => color || props?.theme?.app?.text};
  width: ${({ width }) => width || 'auto'};
  font-weight: ${({ fontWeight }) => fontWeight || '400'};
  margin: ${({ margin }) => margin || ''};
  margin-top: ${({ marginTop }) => marginTop || ''};
  margin-bottom: ${({ marginBottom }) => marginBottom || ''};
  line-height: ${({ $lh }) => $lh || ''};
  margin-left: ${({ ml }) => ml || ''};
  line-height: ${({ lineHeight }) => lineHeight || ''};
  text-align: ${({ textalign }) => textalign || ''};
  line-height: ${({ lh }) => lh || ''};
  cursor: ${({ cursor }) => cursor || ''};
  padding: ${({ padding }) => padding || ''};

  ${({ splashSubtitle }) =>
    splashSubtitle &&
    css`
      font-size: 24px;
      font-weight: 600;
      position: ${({ position }) => position || `absolute`};
      bottom: 7%;
      margin-top: ${({ marginTop }) => marginTop || ''};
      background: linear-gradient(90deg, #5cb617, #00b8f8);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      /* For Firefox (optional): */
      background-clip: text;
      color: transparent;
    `};
  ${({ gradientText }) =>
    gradientText &&
    css`
      background: linear-gradient(90deg, #5cb617, #00b8f8);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      /* For Firefox (optional): */
      background-clip: text;
      color: transparent;
      text-align: center;
    `};
  ${({ setMargin }) =>
    setMargin &&
    css`
      margin: auto;
    `};
  ${({ followerName }) =>
    followerName &&
    css`
      display: flex;
      justify-content: flex-start;
      flex: 1 1 0;
    `};
`

export { TextWrapper }
